<div [formGroup]="group()"
     class="table-responsive">
  <table class="table table-sm table-bordered">
    <thead>
      <tr>
        <th scope="col">Reservation ID</th>
        <th scope="col">Total</th>
        <th scope="col">VAT total</th>
        <th scope="col">Invoice reference</th>
        @if (editMode()) {
          <th scope="col"></th>
        }
      </tr>
    </thead>

    <tbody [formArrayName]="arrayName()">
      @for (control of invoice().controls; track control; let i = $index) {
        <ng-container [formGroupName]="i">
          <!-- Invoice -->
          <tr>
            <td>
              @if (!editMode()) {
                <span>{{ control.get('reservationId')?.value }}</span>
              } @else {
                <input class="form-control"
                       id="reservationId-{{ i }}"
                       type="text"
                       formControlName="reservationId" />
              }
            </td>
            <td>
              @if (!editMode()) {
                <span>{{ control.get('total')?.value }}</span>
              } @else {
                <input class="form-control"
                       id="total-{{ i }}"
                       type="number"
                       formControlName="total" />
              }
            </td>
            <td>
              @if (!editMode()) {
                <span>{{ control.get('vatTotal')?.value }}</span>
              } @else {
                <input class="form-control"
                       id="vatTotal-{{ i }}"
                       type="number"
                       formControlName="vatTotal" />
              }
            </td>
            <td>
              @if (!editMode()) {
                <span>{{ control.get('invoiceReference')?.value }}</span>
              } @else {
                <input class="form-control"
                       id="invoiceReference-{{ i }}"
                       type="text"
                       formControlName="invoiceReference" />
              }
            </td>
            @if (editMode()) {
              <td>
                <button type="button"
                        class="btn btn-outline-danger border-0"
                        (click)="deleteInvoice(i)">
                  <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                </button>
              </td>
            }
          </tr>
          <!-- Lines -->
          <tr formArrayName="lines">
            <td>Lines</td>
            <td colspan="4">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Invoice line code</th>
                    <th scope="col">Description</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Article group code</th>
                    <th scope="col">Billing group code</th>
                    <th scope="col">Total</th>
                    <th scope="col">VAT total</th>
                    <th scope="col">Posting date</th>
                    <th scope="col">Custom reference</th>
                    <th scope="col">Is deleted</th>
                    <th scope="col">Currency code</th>
                    <th scope="col">Revenue type</th>
                    @if (editMode()) {
                      <th scope="col"></th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (row of invoiceLines(i).controls; track row; let ii = $index) {
                    <tr [formGroupName]="ii">
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('invoiceLineCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="invoiceLineCode-{{ ii }}"
                                 type="text"
                                 formControlName="invoiceLineCode" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('description')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="description-{{ ii }}"
                                 type="text"
                                 formControlName="description" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('quantity')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="quantity-{{ ii }}"
                                 type="number"
                                 formControlName="quantity" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('articleGroupCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="articleGroupCode-{{ ii }}"
                                 type="text"
                                 formControlName="articleGroupCode" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('billingGroupCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="billingGroupCode-{{ ii }}"
                                 type="text"
                                 formControlName="billingGroupCode" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('total')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="total-{{ ii }}"
                                 type="number"
                                 formControlName="total" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('vatTotal')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="vatTotal-{{ ii }}"
                                 type="number"
                                 formControlName="vatTotal" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('postingDate')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="postingDate-{{ ii }}"
                                 type="date"
                                 formControlName="postingDate" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('customReference')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="customReference-{{ ii }}"
                                 type="text"
                                 formControlName="customReference" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('isDeleted')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="isDeleted-{{ ii }}"
                                 type="checkbox"
                                 formControlName="isDeleted" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('currencyCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="currencyCode-{{ ii }}"
                                 type="text"
                                 formControlName="currencyCode" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('revenueType')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="revenueType-{{ ii }}"
                                 type="text"
                                 formControlName="revenueType" />
                        }
                      </td>
                      @if (editMode()) {
                        <td>
                          <button type="button"
                                  class="btn btn-outline-danger border-0"
                                  (click)="deleteInvoiceLine(i, ii)">
                            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                          </button>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
              @if (editMode()) {
                <button type="button"
                        class="btn btn-primary float-end"
                        (click)="addInvoiceLine(i)">+ Add line</button>
              }
            </td>
          </tr>
          <!-- Payments -->
          <tr formArrayName="payments">
            <td>Payments</td>
            <td colspan="4">
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Invoice line code</th>
                    <th scope="col">Description</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Article group code</th>
                    <th scope="col">Billing group code</th>
                    <th scope="col">Total</th>
                    <th scope="col">VAT total</th>
                    <th scope="col">Posting date</th>
                    <th scope="col">Custom reference</th>
                    <th scope="col">Currency code</th>
                    @if (editMode()) {
                      <th scope="col"></th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (row of invoicePaymentLines(i).controls; track row; let ii = $index) {
                    <tr [formGroupName]="ii">
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('invoiceLineCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="invoiceLineCode-{{ ii }}"
                                 type="text"
                                 formControlName="invoiceLineCode" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('description')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="description-{{ ii }}"
                                 type="text"
                                 formControlName="description" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('quantity')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="quantity-{{ ii }}"
                                 type="number"
                                 formControlName="quantity" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('articleGroupCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="articleGroupCode-{{ ii }}"
                                 type="text"
                                 formControlName="articleGroupCode" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('billingGroupCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="billingGroupCode-{{ ii }}"
                                 type="text"
                                 formControlName="billingGroupCode" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('total')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="total-{{ ii }}"
                                 type="number"
                                 formControlName="total" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('vatTotal')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="vatTotal-{{ ii }}"
                                 type="number"
                                 formControlName="vatTotal" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('postingDate')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="postingDate-{{ ii }}"
                                 type="date"
                                 formControlName="postingDate" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('customReference')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="customReference-{{ ii }}"
                                 type="text"
                                 formControlName="customReference" />
                        }
                      </td>
                      <td>
                        @if (!editMode()) {
                          <span>{{ row.get('currencyCode')?.value }}</span>
                        } @else {
                          <input class="form-control"
                                 id="currencyCode-{{ ii }}"
                                 type="text"
                                 formControlName="currencyCode" />
                        }
                      </td>
                      @if (editMode()) {
                        <td>
                          <button type="button"
                                  class="btn btn-outline-danger border-0"
                                  (click)="deleteInvoicePaymentLine(i, ii)">
                            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                          </button>
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
              @if (editMode()) {
                <button type="button"
                        class="btn btn-primary float-end"
                        (click)="addInvoicePaymentLine(i)">
                  + Add line
                </button>
              }
            </td>
          </tr>
        </ng-container>
      }
    </tbody>
  </table>

  @if (editMode()) {
    <button type="button"
            class="btn btn-primary"
            (click)="addInvoice(reservation())">+ Add</button>
  }
</div>